export const SUCCESS_SUFFIX = '_SUCCESS';
export const ERROR_SUFFIX = '_ERROR';
export const ABORT_SUFFIX = '_ABORT';
export const CLEAR_REQUESTS_CACHE = 'CLEAR_REQUESTS_CACHE';
export const RESET_REQUESTS = 'RESET_REQUESTS';
export const ABORT_REQUESTS = 'ABORT_REQUESTS';
export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const ADD_WATCHER = 'ADD_WATCHER';
export const REMOVE_WATCHER = 'REMOVE_WATCHER';
export const JOIN_REQUEST = 'JOIN_REQUEST';
export const STOP_POLLING = 'STOP_POLLING';
export const WEBSOCKET_OPENED = 'WEBSOCKET_OPENED';
export const WEBSOCKET_CLOSED = 'WEBSOCKET_CLOSED';
export const GET_WEBSOCKET = 'GET_WEBSOCKET';
export const OPEN_WEBSOCKET = 'OPEN_WEBSOCKET';
export const CLOSE_WEBSOCKET = 'CLOSE_WEBSOCKET';
export const STOP_SUBSCRIPTIONS = 'STOP_SUBSCRIPTIONS';
